import PropTypes from "prop-types"
import React from "react"
import { Accordion, Card as Item } from "react-bootstrap"
import "./accordion-item.scss"

const AccordionItem = ({
  activeIndex,
  content,
  heading,
  index,
  isAccordion,
  subHeading,
}) => {
  return (
    <Item
      aria-label={`${heading} ${
        activeIndex === index ? "Hide the answer" : "Show the answer"
      }`}
      className="accordion-item-wrapper"
      tabIndex="0"
    >
      <Accordion.Toggle as={Item.Header} eventKey={index}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="accordion-item-header-wrapper">
            <p className="accordion-item-title">{heading}</p>
            <p className="accordion-item-subheading">{subHeading}</p>
          </div>
          <img
            alt={heading}
            src={`/images/blue-${activeIndex === index ? "minus" : "plus"}.svg`}
            width="30"
          />
        </div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={index}>
        <Item.Body>
          <div
            className="accordion-item-content"
            dangerouslySetInnerHTML={{
              __html:
                typeof content === "string"
                  ? content
                  : content?.childrenMarkdownRemark?.[0]?.html || "",
            }}
          />
        </Item.Body>
      </Accordion.Collapse>
    </Item>
  )
}

export default AccordionItem

AccordionItem.propTypes = {
  activeIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  heading: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAccordion: PropTypes.bool,
  subHeading: PropTypes.string,
}
